import { Component } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { color } from "d3";
import { ConfirmationService, Message } from "primeng/api";
import { breadcrumb, link } from "src/app/admin/layout/header/header.component";
import { DataService } from "src/app/services/data.service";
import { GlobalConstants } from "src/app/services/global-constants";
import { TranslatorPipe } from "src/app/services/translator.pipe";

@Component({
  selector: "app-ms-dashboard",
  templateUrl: "./ms-dashboard.component.html",
  styleUrl: "./ms-dashboard.component.scss",
})
export class MsDashboardComponent {
  header: string = this.translate("Dashboard");
  links: link[] = [
    {
      name: this.translate("Project"),
      icon: "pi pi-plus",
      link: "/ms/project",
    },
    {
      name: this.translate("Vendor"),
      icon: "pi pi-plus",
      link: "/ms/vendor",
    },
  ];
  breadcrumbs: breadcrumb[] = [
    { name: this.translate("Project"), link: "/ms/project" },
    { name: this.translate("Dashboard"), link: "/ms/dashboard" },
  ];

  isInternalPM: boolean = false;
  projectId: string = "";
  skelition: boolean = true;
  criterias: any[] = [];
  totalCriterias: number = 0;
  criteriaEditIndex: number = -1;
  session: any;

  rowRendered: boolean = false;

  OGselectedBranches: any;

  currentMain = "";
  currentSub = "";

  current: any = {
    criteria: 0,
    subcriteria: 0,
    factor: 0,
  };

  staticURL = GlobalConstants.staticFilesURL;

  //Notificaitons
  messages: Message[] = [];
  project: any;
  channels: any[] = [];
  basicChannels: any;
  selectedBranches: any;
  enquiries: any;
  evaluations: any;
  enquiriesToShow: any;

  documentStyle = getComputedStyle(document.documentElement);
  textColor = this.documentStyle.getPropertyValue("--text-color");

  data: any;

  options = {
    plugins: {
      legend: {
        position: "bottom",
        labels: {
          usePointStyle: true,
          color:"white",
          font: {
            family: "DINNextLTArabic", // specify the font family
            weight: "bold", // specify font weight
          },
        },
      },
    },
  };

  options2 = {
    plugins: {
      legend: {
        display: false,
      },
    },
    scales: {
      x: {
        ticks: {
          font: {
            family: "DINNextLTArabic", // specify the font family
            weight: "bold", // specify font weight
          },color:"white",
        },
      },
      y: {
        // Optionally, you can customize the font for the y-axis ticks as well
        ticks: {
          font: {
            family: "DINNextLTArabic", // specify the font family
            weight: "bold", // specify font weight
          },color:"white",
        },
        max: 100,
      },
    },
  };
  totalBasicChannelsPercentage: any;
  totalForBranches: any;
  sbcGraphData: any;
  getBranchVisitCountNum: any;

  constructor(
    private route: ActivatedRoute,
    private dataService: DataService,
    private router: Router,
    private confirmationService: ConfirmationService,
  ) {}

  ngOnInit() {
    this.route.params.subscribe((params) => {
      this.projectId = params["projectId"];
      // this.links[0].link = '/ms/assign-weights/' + this.projectId;
      if (this.projectId) {
        Promise.all([
          this.getProject(this.projectId),
          this.getCriterias(),
          this.getEnquiries(),
          this.getEvaluations(),
        ]).then(async () => {
          const branch = this.basicChannels.filter(
            (n: any) => n.name == "Branches",
          )[0];
          this.getBranchVisitCountNum = branch.visitCount;

          await this.getBranchLocations();
          await this.selectEnquiry();
          this.setBranchGraph();
          await this.generateGrade();
          this.totalBasicChannelsPercentage = await this.calculateTotalByWeight(
            this.basicChannels,
          );
          console.log(this.totalBasicChannelsPercentage);

          this.getTableData();

          this.makeComments();

          this.getScoringByFactor();

          this.setSBCGraph();

          this.skelition = false;
        });
      }
    });
  }

  async generateGrade() {
    await this.basicChannels.forEach(async (channel: any) => {
      if (channel.name != "Branches") {
        let grade = await this.evaluations
          .filter((e: any) => e.channel._id == channel._id)
          .map((a: any) => a.factors)
          .flatMap((innerArray: any) => innerArray);
        let gradegot = await grade.reduce(
          (accumulator: any, currentValue: { grade: any }) =>
            accumulator + currentValue.grade,
          0,
        );
        let percentage = (gradegot / grade.length / 5) * 100;
        let byweightage = (percentage / 100) * channel.weight ? (percentage / 100) * channel.weight : 0;

        channel.grade = grade;
        channel.gradegot = gradegot;
        channel.percentage = percentage;
        channel.byweightage = byweightage;

        channel.awaitingEval = grade.length > 0;
      } else {
        let branchGraphData = this.generateDataForBranch(this.selectedBranches);
        let grade = branchGraphData;
        let gradegot = branchGraphData.reduce(
          (accumulator: any, currentValue: { grade: any }) =>
            accumulator + currentValue.grade,
          0,
        );
        let percentage = branchGraphData.reduce(
          (accumulator: any, currentValue: { byweightage: any }) =>
            accumulator + currentValue.byweightage,
          0,
        );
        let byweightage = (percentage / 100) * channel.weight ? (percentage / 100) * channel.weight:0;

        channel.grade = grade;
        channel.gradegot = gradegot;
        channel.percentage = percentage;
        channel.byweightage = byweightage;

        channel.awaitingEval = grade.length > 0;
      }
    });

    console.log("this.basicChannels", this.basicChannels);
  }

  calculateTotalByWeight(arg0: any) {
    return arg0.reduce(
      (accumulator: any, currentValue: { byweightage: any }) =>
        accumulator + currentValue.byweightage,
      0,
    );
  }

  setBranchGraph() {
    let branchGraphData = this.generateGraphDataForBranch(
      this.selectedBranches,
    );

    this.data = {
      labels: [
        ...this.selectedBranches.map(
          (item: any) =>
            item.name + " (" + this.branchCities[item.branchId] + ")",
        ),
      ],
      datasets: [
        {
          data: [...branchGraphData],
          backgroundColor: [
            this.documentStyle.getPropertyValue("--color-1"),
            this.documentStyle.getPropertyValue("--color-2"),
            this.documentStyle.getPropertyValue("--color-3"),
            this.documentStyle.getPropertyValue("--color-4"),
            this.documentStyle.getPropertyValue("--color-5"),
            this.documentStyle.getPropertyValue("--color-6"),
          ],
        },
      ],
    };
    console.log(this.data);
  }

  setSBCGraph() {
    this.sbcGraphData = {
      labels: ["Efficency", "Gap"],
      datasets: [
        {
          data: [
            this.totalBasicChannelsPercentage,
            100 - this.totalBasicChannelsPercentage,
          ],
          backgroundColor: [
            this.documentStyle.getPropertyValue("--color-1"),
            "#d2d2d2",
          ],
        },
      ],
    };
  }

  generateBranch(selectedBranches: any) {
    console.log("selectedBranches begin", selectedBranches);
    console.log("evaluations begin", this.evaluations);
    selectedBranches.forEach((item: any) => {
      console.log(this.evaluations);

      let grade = this.evaluations
        .filter((evalu: any) => {
          let variab = evalu;
          if (variab.branch) {
            let var1 = variab.branch._id == item.branchId;
            let var2 = variab.branch.branchId == item.branchId;
            let var3 = var1 || var2;
            return var3;
          } else return false;
        })
        .map((a: any) => a.factors)
        .flatMap((innerArray: any) => innerArray);

      let gradegot = grade.reduce(
        (accumulator: any, currentValue: { grade: any }) =>
          accumulator + currentValue.grade,
        0,
      );
      let percentage = (gradegot / grade.length / 5) * 100;
      let byweightage = (percentage / 100) * item.weight? (percentage / 100) * item.weight : 0;

      item.grade = grade;
      item.gradegot = gradegot;
      item.percentage = percentage;
      item.byweightage = byweightage;
      //item.city = city;
    });

    return selectedBranches;
  }

  generateGraphDataForBranch(selectedBranches: any) {
    const branches = this.generateBranch(selectedBranches);

    this.totalForBranches = branches.reduce(
      (accumulator: any, currentValue: { byweightage: any }) =>
        accumulator + currentValue.byweightage,
      0,
    );

    return branches.map((item: any) => item.percentage);
  }

  generateDataForBranch(selectedBranches: any) {
    const branches = this.generateBranch(selectedBranches);

    this.totalForBranches = branches.reduce(
      (accumulator: any, currentValue: { byweightage: any }) =>
        accumulator + currentValue.byweightage,
      0,
    );

    return branches.map((item: any) => {
      return {
        grade: item.percentage / 20,
        _id: item._id,
        byweightage: item.byweightage,
        percentage: item.percentage,
      };
    });
  }

  findCurrentObject(data: any, _id: any) {
    for (var criteriaIndex in data.criterias) {
      var criteria = data.criterias[criteriaIndex];
      for (var subcriteriaIndex in criteria["sub-criterias"]) {
        var subcriteria = criteria["sub-criterias"][subcriteriaIndex];
        for (var factorIndex in subcriteria["factors"]) {
          var factor = subcriteria["factors"][factorIndex];
          if (factor["_id"] === _id) {
            return {
              criteria: criteriaIndex,
              subcriteria: subcriteriaIndex,
              factor: factorIndex,
            };
          }
        }
      }
    }
    return null; // If _id is not found
  }

  selectEnquiry(): any {
    console.log("this.criterias", this.criterias);

    //const factorId = this.criterias[this.current.criteria]['sub-criterias'][this.current.subcriteria]['factors'][this.current.factor]['_id'];

    const factorId = this.enquiries[0].factorId._id;

    console.log("FACTORID", factorId);

    var foundCurrent = this.findCurrentObject(this.criterias, factorId);
    if (foundCurrent) {
      this.current = {
        criteria: foundCurrent.criteria,
        subcriteria: foundCurrent.subcriteria,
        factor: foundCurrent.factor,
      };
    } else {
      console.log("Could not find object with _id:", factorId);
    }

    let enquiriesToShow = this.enquiries.filter(
      (item: any) => item.factorId._id == factorId,
    );

    console.log("enquiriesToShow", enquiriesToShow);

    let evals: any;

    enquiriesToShow.forEach((item: any) => {
      item.evals = [];

      this.evaluations.forEach((val: any) => {
        item.evals.push({
          branch: val.branch,
          channel: val.channel,
          evals: val.enquiries.filter((a: any) => a._id == item._id),
          factors: val.factors.filter((a: any) => a._id == factorId),
        });
      });
    });

    console.log(enquiriesToShow);

    this.enquiriesToShow = enquiriesToShow;
  }

  async getProject(id: string) {
    try {
      this.skelition = true;
      let res = await this.dataService.getData(`ms-project/${id}`);
      if (res.error) {
        console.log(res.error);
        this.messages = [
          {
            severity: "error",
            summary: this.translate("error"),
            detail: res.msg,
          },
        ];
        return;
      }
      this.project = res.data.data;
      this.channels = res.data.channels.filter(
        (item: any) => item.type == "Basic",
      );
      this.selectedBranches = res.data.channels.filter(
        (item: any) => item.type == "Branch",
      );

      this.OGselectedBranches = res.data.channels.filter(
        (item: any) => item.type == "Branch",
      );

      this.basicChannels = res.data.channels.filter(
        (item: any) => item.type == "Basic",
      );
      this.skelition = false;
    } catch (e: any) {
      this.messages = [
        {
          severity: "error",
          summary: this.translate("error"),
          detail: e.toString(),
        },
      ];
    }
  }

  branchCities: any;

  async getBranchLocations() {
    //this.selectedBranches

    let getBranchIds = this.selectedBranches.map((item: any) => item.branchId);

    // Constructing the query string
    const queryString = getBranchIds
      .map((id: string) => `ids[]=${id}`)
      .join("&");

    const url = `ou/city?${queryString}`;

    try {
      let res = await this.dataService.getData(url);

      if (res.error) {
        console.log(res.error);
        this.messages = [
          {
            severity: "error",
            summary: this.translate("error") + " : " + res.msg,
            detail: res.msg,
          },
        ];
        return;
      } else {
        console.log("CITIES", res.data);

        const object = res.data.reduce((obj: any, item: any) => {
          obj[item._id] = item.city;
          return obj;
        }, {});

        this.branchCities = object;
      }
    } catch (e: any) {
      this.messages = [
        {
          severity: "error",
          summary: this.translate("error") + " : " + e.toString(),
          detail: e.toString(),
        },
      ];
    }
  }

  async getCriterias() {
    try {
      let res = await this.dataService.getData(
        `ms-criteria/project/${this.projectId}/1/1000`,
      );
      if (res.error) {
        console.log(res.error);
        this.messages = [
          {
            severity: "error",
            summary: this.translate("error"),
            detail: res.msg,
          },
        ];
        return;
      }
      this.criterias = res.data.data;

      console.log("CRITERIAS", this.criterias);
    } catch (e: any) {
      this.messages = [
        {
          severity: "error",
          summary: this.translate("error"),
          detail: e.toString(),
        },
      ];
    }
  }

  async getEnquiries() {
    try {
      let res = await this.dataService.getData(
        `ms-enquiry/project/1/10000/${this.projectId}`,
      );
      if (res.error) {
        console.log(res.error);
        this.messages = [
          {
            severity: "error",
            summary: this.translate("error"),
            detail: res.msg,
          },
        ];
        return;
      }
      this.enquiries = res.data;
      console.log("Enquiries", this.enquiries);
    } catch (e: any) {
      this.messages = [
        {
          severity: "error",
          summary: this.translate("error"),
          detail: e.toString(),
        },
      ];
    }
  }

  async getEvaluations() {
    this.skelition = true;
    try {
      let res = await this.dataService.getData(
        "ms-evaluation/project/" + this.projectId,
      );
      if (res.error) return;
      this.evaluations = res.data;
      this.skelition = false;
    } catch (error) {
      console.log(error);
    }
  }

  translate(key: string) {
    let translator: TranslatorPipe = new TranslatorPipe();
    return translator.transform(key);
  }

  extractUsername(name: any) {
    if (name) {
      return name.first + " " + name.middle + " " + name.last;
    }
    return "";
  }

  tableData: any;
  listOfFactors: any;

  getTableData() {
    this.tableData = [];

    var criterias: any = [];

    this.criterias.forEach((main: any) => {
      main["sub-criterias"].forEach((sub: any) => {
        sub.factors.forEach((factor: any) => {
          criterias.push({
            main: main.criteria,
            sub: sub.criteria,
            factor: factor.factor,
            _id: factor._id,
          });
        });
      });
    });

    this.listOfFactors = criterias;

    console.log("criterias", criterias);

    const averages: any = {};

    this.selectedBranches.forEach((branch: any) => {
      if (!branch.averages) {
        branch.averages = {};
      }

      branch.grade.forEach((grade: any) => {
        const factor = criterias.filter(
          (item: any) => item._id == grade._id,
        )[0];

        if (factor && factor.main) {
          const factorMain = factor.main;
          const gradeValue = grade.grade;

          if (!branch.averages[factorMain]) {
            branch.averages[factorMain] = { sum: 0, count: 0, average: 0 };
          }

          branch.averages[factorMain].sum += gradeValue;
          branch.averages[factorMain].count++;
        }
      });
    });

    console.log("averages", averages);

    console.log("this.OGselectedBranches", this.selectedBranches);
  }

  objectKeys(obj: any) {
    if (!obj) {
      return [];
    }
    return Object.keys(obj);
  }

  calculateTotal(): number {
    let total = 0;
    if (this.selectedBranches) {
      this.selectedBranches.forEach((item: any) => {
        total += item.byweightage;
      });
    }
    return total;
  }

  allComments: any;

  makeComments() {
    let comments = this.evaluations
      .map((e: any) => {
        let fact = e.factors
          .filter((f: any) => f.msComments && f.msComments.trim() !== "")
          .map((f: any) => {
            return {
              comment: f.msComments,
              percentage: f.percentage,
              channel: e.channel.name,
              branch: e.branch ? e.branch : null,
              factor: this.listOfFactors.find((l: any) => l._id == f._id),
            };
          });

        return fact;
      })
      .flatMap((innerArray: any) => innerArray)
      .sort((a: any, b: any) => b.percentage - a.percentage);

    console.log("comments", comments);

    this.allComments = comments;
  }

  scoringByFactor: any;
  async getScoringByFactor() {
    let scoring = this.evaluations
      .map((e: any) => {
        let fact = e.factors.map((f: any) => {
          return {
            grade: f.grade,
            percentage: f.percentage,
            factor: this.listOfFactors.find((l: any) => l._id == f._id),
          };
        });

        return fact;
      })
      .flatMap((innerArray: any) => innerArray);

    const tree: any = [];

    await scoring.forEach((item: any) => {
      const { factor, grade } = item;
      const main = factor.main;
      const sub = factor.sub;
      const fact = factor.factor;

      // Find or create main node
      let mainNode = tree.find((node: any) => node.name === main);
      if (!mainNode) {
        mainNode = { name: main, data: [] };
        tree.push(mainNode);
      }

      // Find or create sub node
      let subNode = mainNode.data.find((node: any) => node.name === sub);
      if (!subNode) {
        subNode = { name: sub, data: [] };
        mainNode.data.push(subNode);
      }

      // Find or create fact node
      let factNode = subNode.data.find((node: any) => node.name === fact);
      if (!factNode) {
        factNode = { name: fact, data: [] };
        subNode.data.push(factNode);
      }

      factNode.data.push(grade);
    });

    tree.forEach((m: any) => {
      let main,
        sub = 0;
      m.data.forEach((s: any) => {
        sub = sub + s.data.length;
        s.data.forEach((f: any) => {
          f.data =
            f.data.reduce((acc: number, val: number) => acc + val, 0) /
            f.data.length;
        });
      });
    });

    console.log("scoring", scoring);
    console.log("ttree", tree);

    this.scoringByFactor = tree;
  }

  calculateRowspanHead(node: any): number {
    this.currentMain = node.name;

    return this.calculateRowspan(node);
  }

  calculateRowspan(node: any): number {
    if (!node.data || !Array.isArray(node.data) || node.data.length === 0) {
      return 1; // If node has no children or data is not an array, rowspan is 1
    } else {
      // Recursively calculate rowspan for each child
      const childRowspans = node.data.map((child: any) =>
        this.calculateRowspan(child),
      );
      // Return the sum of child row spans
      return childRowspans.reduce((acc: number, curr: number) => acc + curr, 0);
    }
  }

  calculateGrade(child: any): number {
    //
    let val = child.data.reduce((acc: number, curr: any) => acc + curr.data, 0);
    ;
    return (val / child.data.length) * 20;
  }

  calculateCriteriaGrade(child: any): number {
    //
    let val = child.data.reduce((acc: number, curr: any) => {
      let currval = curr.data.reduce(
        (acc: number, curr: any) => acc + curr.data,
        0,
      );
      return acc + currval;
    }, 0);
    //;
    return (val / this.calculateRowspan(child)) * 20;
  }

  getColorClass(percentage: number): string {
    if (percentage < 25) {
      return "low-progress"; // CSS class for low percentage
    } else if (percentage < 75) {
      return "medium-progress"; // CSS class for medium percentage
    } else {
      return "high-progress"; // CSS class for high percentage
    }
  }

  calculateTotalByFactor(): number {
    let scoring = this.evaluations
      .map((e: any) => {
        let fact = e.factors.map((f: any) => {
          return f.grade;
        });

        return fact;
      })
      .flatMap((innerArray: any) => innerArray);

    let total = scoring.reduce((acc: number, curr: number) => acc + curr, 0);

    return (total / scoring.length) * 20;
  }
}
